import { render, staticRenderFns } from "./DashFinancial.vue?vue&type=template&id=83c16dd2&scoped=true"
import script from "./DashFinancial.vue?vue&type=script&lang=js"
export * from "./DashFinancial.vue?vue&type=script&lang=js"
import style0 from "./DashFinancial.vue?vue&type=style&index=0&id=83c16dd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c16dd2",
  null
  
)

export default component.exports